export { FloatingSection } from './FloatingSection';
export type { FloatingSectionProps } from './FloatingSection';
